import { CRMOportunidade } from "./crmoportunidade";

export class CRMEtapaFunil {
  id: number;
  idCRM: number;
  descricao: string;
  ordem: number;
  excluir: boolean;
  oportunidades: CRMOportunidade[];
  quantidadeOportunidades: number;
  totalOportunidades: number;
  regras: RegrasCRMEtapa;
}

export class RegrasCRMEtapa {
  exibirValor: boolean;
  tipoExibicao: number; // -1: Oportunidades | 0: Orçamentos | 1: Pedidos
  statusOrcamento: number; // 0: Todos | 1: Ativos | 2: Expirados
  etapasPedido: number[];
  quantidade: number;
  sumarizacao: number;
}
